import React from 'react';

export type AppProps = {
  msg: string;
};

const ValidationMessage = (props: AppProps): JSX.Element => {
  const { msg } = props;
  return (
    <p className="help-text" data-test-id="help-text">
      {msg}
    </p>
  );
};

export default ValidationMessage;
